import { Box, makeStyles, Typography } from "@material-ui/core";

import { COLORS } from "../../../../../../theme/colors";

import { Icon } from "../../../../../../components/base";
import { ShaDowBox } from "../../../../../../components/boxes";

const useStyles = makeStyles(() => ({
  textContainer: {
    "& p, h3": {
      color: (props) => props.color,
    },
  },
}));

export const StatusCard = ({ name, icon, number }) => {
  const classes = useStyles({
    color: number > 0 ? COLORS.darks[0][100] : COLORS.darks[0][25],
  });

  return (
    <ShaDowBox>
      <Box pl={2.5} pr={0} pt={2} pb={4} display="flex">
        <Icon src={icon} />
        <Box className={classes.textContainer} ml={1}>
          <Typography>{name}</Typography>
          <Typography variant="h3">
            {number} Building{number > 0 ? "s" : ""}
          </Typography>
        </Box>
      </Box>
    </ShaDowBox>
  );
};
